import { InvoiceStatusPipe } from './invoice.status.pipe';

export function InvoiceStatusFilter ( invoiceStatusPipe : InvoiceStatusPipe ) {
  return ( value : string ) : string => invoiceStatusPipe.transform(value);
}